import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=6538a0c0&scoped=true&"
import script from "./UserName.vue?vue&type=script&lang=js&"
export * from "./UserName.vue?vue&type=script&lang=js&"
import style0 from "./UserName.vue?vue&type=style&index=0&id=6538a0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538a0c0",
  null
  
)

component.options.__file = "UserName.vue"
export default component.exports